module.exports = __webpack_public_path__ + "static/img/4.6390c65.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/4.png
// module id = PHaY
// module chunks = 0